export default {
  obtainOCR(id, params = {}) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/files/ocr/${ id }`, { params });
  },

  retryOCR(id) {
    return this.obtainOCR(id, { retry: 1 });
  },

  getLimit() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/ocr/limit`);
  },
};
